import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "antd";
import { Icon } from 'semantic-ui-react';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import '../components-style.css';
import InvalidObject from '../Common/InvalidObject.js';
import UpdatingParametersPopup from '../../Popup/UpdatingParametersPopup.js';
import DataServiceSQL from "../../DataService/DataServiceSQL.js";
import DeleteObject from '../Common/DeleteObject.js';
import PatientParamsEditTab from './PatientParamsEditTab.js';
import DisplayINSData from './PatientParamsINSTab.js';
import DisplayShareData from './PatientParamsShareTab.js';
import DeleteShare from '../Shares/DeleteShare.js';
import {FormattedMessage, useIntl} from 'react-intl';
import gatewayFunctionsGetter from '../../Controller/getSQLGatewayFunctions.js';
import Utils from "../Common/Utils.js";

const ProfileParameters = (props) => {

    const [invalidValuePopup, setInvalidValuePopup] = useState(false);

    const [changingParamatersPopup, setChangingParamatersPopup] = useState(false);
    const [changingParamatersPopupMessage, setChangingParamatersPopupMessage] = useState("Saving new parameters, please wait...");

    const [showCloseButton, setShowCloseButton] = useState(false);

    const [displayDeletePatientPopup, setDisplayDeletePatientPopup] = useState(false);
    const [displayEditPatientPopup, setDisplayEditPatientPopup] = useState(false);
    const [displayUnsharePopup, setDisplayUnsharePopup] = useState(false);

    const [message, setMessage] = useState("");

    const [gw_list, setGatewayList] = useState([{ 'id_gw':"dissociate", 'gw_name':"", 'nickname':'--', 'fullname':"No association" }]);         // list to store gateway
    const [device_list, setDeviceList] = useState(props.structure_devices);          // list to store device

    const [activeTab, setActiveTab] = useState('1');

    // Bumped whenever another tab (e.g. the speciality practitioner assignment
    // in the Settings tab) mutates the patient's structure shares, so the Shares
    // tab can re-fetch and display the change without a full reload.
    const [shareRefreshSignal, setShareRefreshSignal] = useState(0);
    const refreshShares = () => setShareRefreshSignal(s => s + 1);

    useEffect(() => {
        getAvailableGateway();
    }, 
    //eslint-disable-next-line 
    [props.structure_gateways]);

    const intl = useIntl();
    const noAssociationMsg = intl.messages["param.noAssociation"];


    // ###### RENDER SECTION ######

    //Function to render delete icon
    const renderDeleteIcon = () => {
        return(
            <div>
                {(props.profileData.Patient_Data.FK_User_mail === props.accountInformation.email && props.accountInformation.readOnly !== true) ?
                    <div>
                        {(props.profileData.Patient_Data.monitoring_activation === "no") ?
                            <Card id="box-delete-nomonitoring">
                                <Col id="col-delete">
                                    <button onClick={manageDeletePatientDisplay} style={{backgroundColor: "#3A5774", borderRadius: "5px", border:"0px", fontSize: "1.2em"}}>
                                        <Icon name='trash' size='large' color='black' style={{margin:"3px"}}/>
                                    </button>
                                </Col>
                            </Card>
                            :
                            <Card id="box-delete">
                                <Col id="col-delete">
                                    <button onClick={manageDeletePatientDisplay} style={{backgroundColor: "#30677F", borderRadius: "5px", border:"0px", fontSize: "1.2em"}}>
                                        <Icon name='trash' size='large' color='black' style={{margin:"3px"}}/>
                                    </button>
                                </Col>
                            </Card>
                        }
                    </div>
                    :
                    null
                }
            </div>
        )
    }



    // ###### GETTER SECTION ######

    // Function to order device by their alphabetical order
    const convertDeviceAlphabetical = (type, sn) => {
        let converted = "";
        switch (type) {
            case "BP2A":
            case "BPB6":
                converted = "Tensiometre"
                break
            case "FS20F":
                converted = "Oximeter"
                break
            case "LESCALE":
            case "S5":
                converted = "Scale"
                break
            case "none": //this case is used to make sure the first device option in list is none
                converted = "A"
                break
            case "Tucky":
                if (sn.includes('-')) {
                    converted = "Thermometer"
                }
                else {
                    converted = "Tucky"
                }
                break
        }
        return converted
    }

    // Function to get list of gateway and associated id
    const getAvailableGateway = async () => {
        let local_gw_List = props.structure_gateways;
    
        let temp_gw_List = [{ 'id_gw':"dissociate", 'gw_name':"dissociate", 'nickname':'--', 'fullname':noAssociationMsg }];    
          
        if ((local_gw_List !== "none")&&(local_gw_List !== undefined)&&(local_gw_List.length !== 0)){    
          local_gw_List.forEach(item =>{
              temp_gw_List.push({ 'id_gw':item.id_gw, 'gw_name': item.gw_name, 'nickname': item.nickname, 'fullname': item.nickname + " (" + item.gw_name+ ")" });
          })
        }    
    
        setGatewayList(temp_gw_List);
    };



    // ###### FUNCTIONS RELATED TO SHARE ######

    //Function to handle unshare popup display
    const ManageUnsharePatientDisplay = () => {
        setDisplayUnsharePopup(!displayUnsharePopup)
    }

    //Function to close popup after patient unshare
    const closeAfterUnshare = async() => {
        await props.reloadUserAndProfiles();
        ManageUnsharePatientDisplay();      
    };

    /**   /!\ TRANSLATION /!\  **/
    //Function to launch unshare popup display and ask user to confirm (or not) unshare
    const deleteShare = async () => {
        if(props.accountInformation.email === props.profileData.Patient_Data.FK_User_mail){
            setMessage(<FormattedMessage id = "share.deleteQuestionOwner" defaultMessage = {"Are you sure you want to stop sharing that profile with " + props.profileData.Patient_Data.shares.email + "?"} values = {{account_mail: props.profileData.Patient_Data.shares.email}} />)
        }
        else{
            setMessage(<FormattedMessage id = "share.deleteQuestionReceiver" defaultMessage = {"Are you sure you want to remove that share from " + props.profileData.Patient_Data.FK_User_mail + "?"} values = {{account_mail: props.profileData.Patient_Data.FK_User_mail}} />)
        }
        ManageUnsharePatientDisplay();
    }


    // ###### POPUP DISPLAY MANAGEMENT FUNCTIONS ######

    ////Function to close invalid popup
    const cancelInvalidValuePopup = () => {
        setInvalidValuePopup(false);
    }

    //Function to close invalid popup
    const cancelChangingParamatersPopup = () => {
        setChangingParamatersPopupMessage("Saving new parameters, please wait...");
        setShowCloseButton(false);
        setChangingParamatersPopup(false);
    }

    //Function to handle delete patient popup display
    const manageDeletePatientDisplay = () => {
        setDisplayDeletePatientPopup(!displayDeletePatientPopup)
    };

    //Function to close popup after patient deletion
    const closeAfterDeletion = () => {
        manageDeletePatientDisplay();
        props.reloadUserAndProfiles();
    };

    //Function to handle display of edit patient popup
    const manageEditPatientDisplay = () => {
      setDisplayEditPatientPopup(!displayEditPatientPopup)
    };

    //Function to close popup after patient edition
    const closeAfterEdition = () => {
        manageEditPatientDisplay();
    };

    // ###########

   	return(
        <div>
            <Card id="box-extended-view-profile">
                <Nav tabs style={{ backgroundColor:props.tabColor }}>
                    <NavItem>
                        <NavLink className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                            <FormattedMessage id="param.settingTab" defaultMessage="Settings" />
                        </NavLink>
                    </NavItem>
                        <NavItem>
                            <NavLink className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                            <FormattedMessage id="param.insTab" defaultMessage="INS data" />
                            </NavLink>
                        </NavItem>
                    {(((props.userRole === "admin")||(props.userRole === "staff"))&&(props.accountInformation.email === props.profileData.Patient_Data.share_info.owner)) ?
                        null
                        :
                        <NavItem>
                            <NavLink className={activeTab === '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>
                                <FormattedMessage id="param.sharesTab" defaultMessage="Shares" />
                            </NavLink>
                        </NavItem>
                    }

                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <PatientParamsEditTab
                            profileData = {props.profileData}
                            gw_list={gw_list}
                            device_list={props.structure_devices}
                            group_list={props.structure_groups}
                            structure_Id={props.structure_Id}
                            accountInformation={props.accountInformation}
                            userRole={props.userRole}
                            subscription_info={props.subscription_info}
                            closeAfterEdit={closeAfterEdition}
                            cancelPopup={manageEditPatientDisplay}
                            updateProfileParameters={props.updateProfileParameters}
                            reloadUserAndProfiles={props.reloadUserAndProfiles}
                            onSharesChanged={refreshShares}
                            select_tooltip={props.select_tooltip}
                            displayDevicesParams={props.displayDevicesParams}
                            changeDisplayDevices={props.changeDisplayDevices}
                            changeOngoing={props.changeOngoing}
                            setChangeOngoing={props.setChangeOngoing}
                            hidePatientIds={props.hidePatientIds}
                        />
                    </TabPane>
                    <TabPane tabId="2">
                        <DisplayINSData
                            accountInformation={props.accountInformation}
                            profileData={props.profileData}
                            reloadUserAndProfiles={props.reloadUserAndProfiles}
                            subscription_info={props.subscription_info}
                            changeOngoing={props.changeOngoing}
                            setChangeOngoing={props.setChangeOngoing}
                        />
                    </TabPane>
                    {(((props.userRole === "admin")||(props.userRole === "staff"))&&(props.accountInformation.email === props.profileData.Patient_Data.share_info.owner)) ?
                        null
                        :
                        <TabPane tabId="3">
                            <DisplayShareData
                                profileData={props.profileData}
                                accountInformation={props.accountInformation}
                                reloadUserAndProfiles={props.reloadUserAndProfiles}
                                subscription_info={props.subscription_info}
                                refreshSignal={shareRefreshSignal}
                            />
                        </TabPane>
                    }
                </TabContent>
            </Card>

            {!Utils.checkBit(props.subscription_info.features, Utils.featureToBitNumber("patient_add_delete_block")) ?
                renderDeleteIcon()
                :
                null
            }

            {invalidValuePopup ?
                <InvalidObject
                    cancelPopup={cancelInvalidValuePopup}
                    message={"Error"}
                />
                :
                null
            }
            {displayDeletePatientPopup ? 
                <DeleteObject
                    cancelPopup={manageDeletePatientDisplay}
                    object_type={"patient"}
                    closeAfterDelete={closeAfterDeletion}
                    accountInformation={props.accountInformation}
                    structure_Id={props.structure_Id}
                    patient={props.profileData}
                    subscription_info={props.subscription_info}
                    object_name={props.profileData.Patient_Data.firstname + " " + props.profileData.Patient_Data.lastname}
                />
                :
                null
            }
            {displayUnsharePopup ?
                <DeleteShare
                    message={message}
                    closeAfterUnshare={closeAfterUnshare}
                    accountInformation={props.accountInformation}
                    structure_Id={props.structure_Id}
                    subscription_info={props.subscription_info}
                    cancelPopup = {ManageUnsharePatientDisplay}
                    patient={props.profileData}
                />
                :
                null
            }
        </div>
   	);
}
export default (ProfileParameters);